import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

interface DocumentCheckboxProps {
  /** Current selection state */
  isSelected: boolean;
  /** Callback when selection changes */
  onSelect: (isSelected: boolean) => void;
  /** Disable checkbox */
  disabled?: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * DocumentCheckbox - Molecule component
 *
 * Styled checkbox for document selection.
 * Wraps Checkbox atom with accessible label and custom styling.
 */
export function DocumentCheckbox({
  isSelected,
  onSelect,
  disabled = false,
  className,
}: DocumentCheckboxProps) {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <Checkbox
        checked={isSelected}
        onCheckedChange={(checked) => onSelect(checked === true)}
        disabled={disabled}
        aria-label="Select document"
      />
    </div>
  );
}
